import { useRecoilValue } from "recoil";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "../states/user";

/**
 * 사용자 정보(학생, 보호자, 로그인 타입)를 한번에 가져오는 커스텀 훅
 * @returns {Object} { student, guardian, loginType, studentId }
 */
export const useUserInfo = () => {
  const student = useRecoilValue(studentUserState);
  const guardian = useRecoilValue(guardianUserState);
  const loginType = useRecoilValue(loginTypeState);

  // 학생 || 보호자의 아이디 조회
  const studentId =
    loginType === "student" ? student?.id : guardian?.student?.id;

  return {
    student,
    guardian,
    loginType,
    studentId,
  };
};
